import React from 'react';
import { LoadingLayout } from 'components/molecules/Loaders/LoadingLayout';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { GraphQLError } from 'graphql';
import { useQuery } from '@apollo/client';
import CommandeUpdateView from './CommandeUpdate.view';
import { getCommandeDefFromQuery } from '../../helpers/transformApiResponse/commande';
import QUERY_COMMANDE_DETAILS from '../../graphql/query/commande/commandeDetails';
import { CommandeDetailsQuery } from '../../graphql/generated/graphql';

const CommandeUpdate = props => {
  const { data, error, loading } = useQuery<CommandeDetailsQuery>(
    QUERY_COMMANDE_DETAILS,
    {
      variables: { id: props && props.match && props.match.params.id }
    }
  );

  if (loading) return <LoadingLayout />;
  if (error)
    return (
      <ErrorContainer
        detailErr={
          new GraphQLError('Erreur dans la récupération de la commande')
        }
      />
    );
  return (
    <CommandeUpdateView
      commande={getCommandeDefFromQuery(data.commande.data)}
    />
  );
};
export default CommandeUpdate;
